<div class="elementsBar row">
  <div class="elementsBarBtns col-6">
    @if (permissions?.insert) {
    <button mat-button (click)="showCreate()" class="CreatButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#addItem"></use>
      </svg>
      {{ 'create' | translate }}
    </button>
    }
    <button mat-button (click)="showFilterPopup()" class="FilterButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#filterSearch"></use>
      </svg>
      {{ 'filter' | translate }}
    </button>

    <button mat-button (click)="favouriteClick()" [style.color]="favColor" class="FavoriteButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#star-colored"></use>
      </svg>
      {{ 'addtoFavorite' | translate }}
    </button>

    <!-- @if (showRestoreBtn) {
    <button mat-button (click)="restore()" class="RestoreButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#reload"></use>
      </svg>
      {{ 'restore' | translate }}
    </button>
    } -->
  </div>

  <div class="searchExport col-6 p-t-20">

    @if (permissions?.print || permissions?.export) {
    <mat-form-field appearance="outline" class="Export">
      <mat-label>{{ 'more' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedOption" name="exOption">
        @for (exOption of exportOptions; track exOption) {
        <mat-option [value]="exOption.value" (click)="onOptionClicked(exOption.value)">{{ exOption.viewValue | translate
          }}</mat-option>
        }

        @for (item of extraDynamicMenu; track item) {
        <mat-option [value]="'Command_' + item.functionName"
          (click)="onOptionClicked('Command_' + item.functionName)">{{
          item.commandName | translate
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
  </div>
</div>